import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { filter } from 'rxjs';

import { MobileMenuComponent } from '@bn/layout';
import { ContentService } from '@bn/shared/core/services';

import { mobileMenuConfig } from './mobile-menu.config';
import { SidebarComponent } from './sidebar/sidebar.component';

@Component({
  selector: 'bn-partner-portal-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  imports: [RouterOutlet, SidebarComponent, MobileMenuComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent {
  public readonly contentService = inject(ContentService);

  public readonly isMobileMenuOpened = signal(false);

  public readonly mobileMenuItems = mobileMenuConfig;

  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  public constructor() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.isMobileMenuOpened.set(false));
  }

  public onToggleMenu(open: boolean): void {
    this.isMobileMenuOpened.set(open);
  }
}
